<template>
  <div class="roleList">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="$t.roleList.searchText"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">{{ $t.roleList.role }}：{{ item.RoleName }}</div>
        <div class="buttons">
          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="dialogShow(item)"
            >{{ $t.meta.editButton }}</van-button
          >

          <van-button
            class="danger-btn"
            size="small"
            type="primary"
            @click="dialogDeleteShow(item.RoleId)"
          >
            {{ $t.meta.delete }}
          </van-button>

          <van-button
            class="warning-btn"
            size="small"
            type="primary"
            @click="gotoDetail(item.RoleId)"
          >
            {{ $t.roleList.setRight }}</van-button
          >
        </div>
      </div>
    </van-list>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.roleList.roleClass }}</div>
        <van-radio-group v-model="roleLevel" direction="horizontal">
          <van-radio :name="3">{{ $t.roleList.manager }}</van-radio>
          <van-radio :name="4">{{ $t.roleList.distributor }}</van-radio>
        </van-radio-group>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-dialog
      :title="dialogType == 'edit' ? $t.roleList.editRole : $t.roleList.addRole"
      width="90%"
      v-model="dialogVisible"
      @confirm="dialogConfirm"
      @cancel="dialogCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="roleList-alert">
          <van-form label-width="120px">
            <van-field
              v-model="addForm.roleName"
              :label="$t.roleList.role"
              :placeholder="$t.meta.input"
              required
            />

            <div class="roleList-radio">
              <div class="radio-label">
                {{ $t.roleList.roleClass }}
              </div>
              <van-radio-group
                v-model="addForm.roleLevel"
                direction="horizontal"
                @change="handleRadioChange"
              >
                <van-radio name="3" @click="handleRadio">{{
                  $t.roleList.manager
                }}</van-radio>
                <van-radio name="4" @click="handleRadio">{{
                  $t.roleList.distributor
                }}</van-radio>
              </van-radio-group>
            </div>
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-dialog
      :title="$t.meta.notice"
      width="90%"
      v-model="showDeleteDialog"
      @confirm="deleteRoles"
      @cancel="showDeleteDialog = false"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <div style="margin: 20px; text-align: center">
        {{ $t.roleList.dialogText }}
      </div>
    </van-dialog>

    <div class="tool-bar">
      <van-button type="info" block @click="dialogShow(null)">{{
        $t.roleList.addRole
      }}</van-button>
    </div>
  </div>
</template>

<script>
import {
  List,
  Form,
  Field,
  Button,
  Popup,
  Switch,
  Search,
  Col,
  Row,
  Radio,
  RadioGroup,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Form)
  .use(Field)
  .use(Button)
  .use(Popup)
  .use(Switch)
  .use(Search)
  .use(Col)
  .use(Row)
  .use(Radio)
  .use(RadioGroup);

export default {
  name: "roleList",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //dialog
      dialogType: "add",
      dialogVisible: false,
      addForm: {
        roleId: null,
        roleName: "",
        roleLevel: null,
      },
      checkRadioFlag: false,
      //delete
      dialogDeleteId: "",
      showDeleteDialog: false,
      //filter
      searchText: "",
      roleLevel: null,
      showFilter: false,
    };
  },
  created() {},
  methods: {
    handleRadioChange() {
      this.checkRadioFlag = true;
    },
    handleRadio() {
      if (!this.checkRadioFlag) {
        this.addForm.roleLevel = null;
      }
      this.checkRadioFlag = false;
    },
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "roleDetail",
        name: "roleDetail",
        query: [
          {
            name: "RoleId",
            value: id,
          },
        ],
      });
    },
    dialogConfirm() {
      if (this.dialogType == "add") {
        this.addRoles();
      }
      if (this.dialogType == "edit") {
        this.editRoles();
      }
    },
    dialogCancel() {
      this.initData();
      this.dialogVisible = false;
    },
    dialogShow(item) {
      if (item) {
        this.dialogType = "edit";
        this.addForm.roleId = item.RoleId;
        this.addForm.roleName = item.RoleName;
        this.addForm.roleLevel = item.RoleLevel > 2 ? item.RoleLevel : null;
      } else {
        this.initData();
      }
      this.dialogVisible = true;
    },
    initData() {
      this.dialogType = "add";
      this.addForm.roleId = null;
      this.addForm.roleName = "";
      this.addForm.roleLevel = null;
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (this.roleLevel) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.roleLevel = null;
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    addRoles() {
      this.$commonMethod.showLoading();
      var param = {
        RoleName: this.addForm.roleName,
        RoleLevel: this.addForm.RoleLevel,
        CompanyId: this.CompanyId,
      };
      this.$api.systemManagement
        .addRoles(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.dialogVisible = false;
          this.initData();
          this.initList();
          this.getList();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    editRoles() {
      this.$commonMethod.showLoading();
      var param = {
        RoleId: this.addForm.roleId,
        RoleName: this.addForm.roleName,
        RoleLevel: this.addForm.roleLevel,
        CompanyId: this.CompanyId,
      };
      this.$api.systemManagement
        .editRoles(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.dialogVisible = false;
          this.initData();
          this.initList();
          this.getList();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogDeleteShow(id) {
      this.dialogDeleteId = id;
      this.showDeleteDialog = true;
    },
    deleteRoles() {
      this.$commonMethod.showLoading();
      var param = {
        RoleIds: this.dialogDeleteId,
        CompanyId: this.CompanyId,
      };
      this.$api.systemManagement
        .deleteRoles(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        RoleName: this.searchText,
        RoleLevel: this.roleLevel,
        CompanyId: this.CompanyId,
      };
      this.$api.systemManagement
        .getRoleList(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.roleList {
  ::v-deep .van-sidebar-item--select::before {
    background-color: #1890ff !important;
  }
  ::v-deep .van-tree-select__item {
    font-weight: normal !important;
  }
  .roleList-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-radio {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 14px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
        .tag-group {
          margin-top: 10px;
          .tag-group-title {
            color: #1890ff;
          }
        }
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .warning-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: #ffba00;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .roleList-alert {
    overflow: scroll;
    max-height: 100vw;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
